import { mapGetters } from 'vuex'
import { accessChecks } from '../../../middleware/checkups'

export default {
  data () {
    return {
      bookmarkTrash: {
        label: this.$t('mybookmarks.mosaic.trash'),
        dataWptv: 'mosaique-supprimer'
      }
    }
  },
  computed: {
    ...mapGetters({
      profile: 'core/getProfile',
      getBookmarkById: 'bookmarks/getBookmarkById'
    })
  },
  methods: {
    onSelectBookmark (item, bookmarkId, bookmarked) {
      return accessChecks(this.$store, this.profile, false, true, false, this.$route)
        .then(() => {
          this.sendStats(this.$stats.bookmarks.onSelectBookmark(bookmarked, item))
          return bookmarked ? this.$store.dispatch('bookmarks/deleteBookmark', { bookmarkId }) : this.$store.dispatch('bookmarks/addBookmark', item)
        })
        .then(() => this.$store.dispatch('bookmarks/getBookmarks'))
    },
    deleteBookmark (itemId) {
      const bookmark = this.getBookmarkById(itemId)
      if (bookmark) {
        this.sendStats(this.$stats.bookmarksAlerts.onClickDeleteItemFromBookmarksAlerts(bookmark))
        this.$store.dispatch('bookmarks/deleteBookmark', { bookmarkId: bookmark.bookmarkId })
          .then(() => this.$store.dispatch('bookmarks/getBookmarks'))
          .then(() => {
            const sortAndFilter = this.$refs.sortAndFilter
            if (sortAndFilter) {
              sortAndFilter.onItemsUpdated()
            }
          })
      }
    }
  }
}
